import { create } from "zustand";
import { has, isArray, isObject } from "lodash";
import type { ContextStoreProps } from "./lib/type";

export const useContextStore = create<ContextStoreProps>((set, get) => ({
  contextId: undefined,
  variables: {},
  getVariable: (key) => {
    const variables = get().variables;
    if (key && has(variables, key)) {
      return variables[key];
    }
  },
  getVariableAsFormValue: (key) => {
    const variable = get().getVariable(key);
    if (variable) {
      return { [variable.key]: variable.value };
    }
  },
  updateVariableValue: (key, value) => {
    const variables = get().variables;
    const variableToUpdate = get().getVariable(key);

    if (isObject(variables) && isObject(variableToUpdate)) {
      return set({
        variables: {
          ...variables,
          [key]: {
            ...variableToUpdate,
            value,
          },
        },
      });
    }
  },
  replaceVariablesObject: (variables) => {
    if (!isArray(variables)) return;

    const variablesObject = variables.reduce(
      (acc, item) => {
        if (isObject(acc) && !has(acc, item.key)) {
          acc[item.key] = item;
        }
        return acc;
      },
      {} as ContextStoreProps["variables"],
    );
    return set({
      variables: variablesObject,
    });
  },
  appendVariableToVarObject: (variable) => {
    if (!variable) return;

    set((state) => ({
      variables: { ...state.variables, [variable.key]: variable },
    }));
  },
  appendVariablesListToVarObject: (variables) => {
    if (!isArray(variables)) return;
    const appendVariableToVarObject = get().appendVariableToVarObject;
    variables.forEach((item) => {
      appendVariableToVarObject(item);
    });
  },
}));
